export default __webpack_public_path__ + "static/media/cvod-RP18.39a5f116.svg";